import React from "react";
import { cn } from "./utils";

import * as Charts from "./lib";

// import type { ChartProps } from "./Charts.types";

import { chartWrapper } from "./Chart.styles";

export const Chart = ({
  name,
  data,
  dataKey,
  dataset,
  layout,
  tickAngle,
  showLegend,
  size,
  domain,
  className,
  ...props
}) => {
  const ChartComponent = Charts[name];
  const layoutProps = layout ? { layout } : {};

  return (
    <div className={cn(chartWrapper(), className)}>
      <ChartComponent
        name={name}
        data={data}
        dataKey={dataKey}
        dataset={dataset}
        tickAngle={tickAngle}
        showLegend={showLegend}
        size={size}
        domain = {domain}
        {...layoutProps}
        {...props}
      />
    </div>
  );
};
